import { Logo, LogOutContainer } from './Header.styled';

export default function LogOutMenu() {
  return (
    <>
      <LogOutContainer>
        <Logo>BR</Logo>
      </LogOutContainer>
    </>
  );
}
